/**
 * Source of uploaded file group
 */
export enum RebateLoadFileSourceTypeModel {
	/**
	 * Uploaded manually from UI
	 */
	Default = 1,
	/**
	 * Uploaded from synapse by API
	 */
	Synapse = 2
}
